import { render, staticRenderFns } from "./ProductDetails.vue?vue&type=template&id=2c1b9405&scoped=true&"
import script from "./ProductDetails.vue?vue&type=script&lang=js&"
export * from "./ProductDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetails.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ProductDetails.vue?vue&type=style&index=1&id=2c1b9405&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../nonspa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1b9405",
  null
  
)

component.options.__file = "ProductDetails.vue"
export default component.exports